var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/inherits");

var Web3 = require('web3');

var Signer = require('./Signer');

var arrayEquals = function arrayEquals(a, b) {
  return a.length === b.length && a.every(function (val, i) {
    return val === b[i];
  });
};

var InjectedSigner =
/*#__PURE__*/
function (_Signer) {
  "use strict";

  _inherits(InjectedSigner, _Signer);

  function InjectedSigner() {
    var _this;

    _classCallCheck(this, InjectedSigner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InjectedSigner).call(this));
    _this.accounts = [];

    if (_this.isAvailable()) {
      _this.web3 = new Web3(_this._provider());

      _this.updateAccounts();

      if (window.ethereum && window.ethereum.enable) {
        window.ethereum.enable().then(function () {
          return _this.updateAccounts();
        });
      }
    }

    return _this;
  }

  _createClass(InjectedSigner, [{
    key: "isAvailable",
    value: function isAvailable() {
      return !!(window.ethereum || window.web3 && window.web3.currentProvider);
    }
  }, {
    key: "signTx",
    value: function signTx(tx) {
      return this.web3.eth.signTransaction(tx);
    }
  }, {
    key: "signMsg",
    value: function signMsg(msg, account) {
      return this.web3.eth.sign(msg, account);
    }
  }, {
    key: "shouldSkipSigning",
    value: function shouldSkipSigning() {
      return !!this._provider().isMetaMask;
    }
  }, {
    key: "updateAccounts",
    value: function () {
      var _updateAccounts = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var accounts;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.web3.eth.getAccounts();

              case 2:
                accounts = _context.sent;

                if (!arrayEquals(accounts, this.accounts)) {
                  this.accounts = accounts;
                  this.events.emit('accountChange');
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateAccounts() {
        return _updateAccounts.apply(this, arguments);
      }

      return updateAccounts;
    }()
  }, {
    key: "_provider",
    value: function _provider() {
      return window.ethereum || window.web3.currentProvider;
    }
  }]);

  return InjectedSigner;
}(Signer);

module.exports = InjectedSigner;